<template>
    <section class="col s12">
        <div class="row" v-for="(avaliacao, avaliacao_i) in avaliacoes" :key="avaliacao_i">
            <div class="input-field col s12">
				<template v-if='avaliacao.invalido'> 
					<strong style="color:gray">
						Parecer do Avaliador {{ avaliacao_i + 1 }} *
					</strong>
					<p style="color:gray">--
					</p>
				</template>
				<template v-else> 
					<strong>
						Parecer do Avaliador {{ avaliacao_i + 1 }}
					</strong>

					<textarea style="width: 100%; min-height: 150px;"
							  name="pareceresDosAvaliadores"
							  :id="'parecerAvaliacao_' + avaliacao_i"
							  disabled
							  maxlength="1500"
							  v-model="avaliacao.parecer"
							  cols="30" rows="10"
							  class="browser-default"></textarea>
				</template>
			</div>
        </div>
    </section>
</template>

<script>
export default {
    name: "pareceres_dos_avaliadores",
    props: {
        pAvaliacoes: {
            type: Array,
            default: () => { return [] },
        },
    },
    data() {
        return {
            avaliacoes: this.pAvaliacoes,
        }
    },
    watch: {
        pAvaliacoes(newValue) {
            this.avaliacoes = newValue
        },
    },
}
</script>

<style scoped>

</style>
